














import { Vue, Component } from 'vue-property-decorator';
import tinymce from '@/components/Common/tinymceEditor/tinymceEditor.vue';
//
@Component({
  components: {
     tinymce
  }
})
export default class CourseIntro extends Vue {
  // newfileList: any = [];
  // upLoadType: any = [];
  toolbar:any=[
    'fontsizeselect bold italic underline strikethrough | codesample | blockquote   preview fullscreen | alignleft aligncenter alignright | imageUpload image  |'
  ]
  describes = ''
  created() {
    if(this.$route.query.id && sessionStorage.courseInfo) {
      const courseInfo: any = JSON.parse(sessionStorage.getItem('courseInfo') as string)
      this.describes = courseInfo.describes
    }
    if(this.$store.state.courseStore.seniorSettingParams.describes){
      this.describes = this.$store.state.courseStore.seniorSettingParams.describes
    }
  }
  destroyed() {
    this.$store.state.courseStore.seniorSettingParams.describes = this.describes;
  }
  // // 获取编辑器内容
  getEditorContent(val: string) {
    console.log(val)
    //this.editContent = val;
  }
  //
  // // 上传
  // uploadEditor() {
  //   let el: any = document;
  //   el.getElementById('ShortAnswer2')
  //     .click();
  //   this.newfileList = [];
  //   this.upLoadType = '2';
  // }
}
